import canchaImage from "../../../images/fundacioncancha.webp";
import heroImage from "../../../images/fundacion1.webp";

const firstBoardMembers = [
    "Alberto Pesce (Presidente)",
    "Rodolfo Di Corcia (Secretario)",
    "Raúl Solessi (Pro Secretario)",
    "Hugo Di Corcia (Tesorero)",
    "Gualberto Toletti (Pro Tesorero)",
    "Pedro Belloso, Gilberto Díaz y Julián Palermo (Vocales)",
];

const foundingMembers = [
    "Julio Astengo",
    "Pedro Belloso",
    "Armando Carlotta",
    "Virgilio Cardozo",
    "Alberto De Los Santos",
    "Antonio Di Corcia",
    "Hugo Di Corcia",
    "Rodolfo Di Corcia",
    "Hugo Ferrando",
    "Eduardo García",
    "Romeo García",
    "José M. Huertas",
    "Alcides Isbardo",
    "Domingo Morgada",
    "Enrique Morgada",
    "José M. Morgada",
    "Héctor Naya",
    "Leopoldo Olhagaray",
    "Antonio Paglietini",
    "Julián Palermo",
    "Alberto Pesce",
    "Gilberto Pérez",
    "Agustín Regiardo",
    "Juan Signorini",
    "Walter Solari",
    "Helvecio Tetti",
    "Gualberto Toletti",
    "Julián Varela",
    "Raúl M. Zolessi",
];

const firstTitles = [
    {
        year: "1925",
        description: "Campeón de Intermedia, el primer título oficial del club.",
        borderClass: "border-red-500",
    },
    {
        year: "1926",
        description: "Bicampeonato de Intermedia y ascenso a Primera División.",
        borderClass: "border-green-500",
    },
    {
        year: "1927",
        description: "Debut en Primera División y primera victoria: 23 a 22 ante la Asociación Cristiana.",
        borderClass: "border-slate-500",
    },
];

function FundacionContent() {
    return (
        <div className="space-y-12 pb-12 md:space-y-24">
            <section className="relative">
                <span className="pointer-events-none absolute -left-2 -top-10 select-none text-5xl font-black text-red-500/20 md:text-6xl">
                    28 FEB 1922
                </span>
                <div className="mb-8 md:mb-12 rounded-r-lg border-l-4 border-green-500 bg-gradient-to-r from-emerald-900/40 to-red-900/40 px-5 py-5 backdrop-blur-sm md:px-8">
                    <h2 className="text-2xl md:text-3xl font-black uppercase tracking-wider text-white">
                        Fundacion de Aguada
                    </h2>
                    <p className="mt-2 text-lg font-bold text-red-400">28 de febrero de 1922</p>
                </div>

                <div className="grid items-start gap-8 md:grid-cols-2 md:gap-16">
                    <div className="space-y-6">
                        <p className="text-lg leading-relaxed text-slate-300">
                            El 28 de febrero de 1922, un grupo de jóvenes de apenas 14 a 16 años fundó el Club Atlético Aguada en la casa y farmacia de la familia Di Corcia, donde hoy está Ramón Escobar 1324. La calle llevaba entonces el nombre de Madrid.
                        </p>
                        <div className="rounded-lg border border-white/10 bg-[#0b2218]/70 p-6">
                            <h4 className="mb-4 text-sm font-bold uppercase tracking-widest text-green-400">
                                Primera Comision Directiva
                            </h4>
                            <ul className="grid gap-2 text-sm text-slate-400 md:grid-cols-2">
                                {firstBoardMembers.map((member) => (
                                    <li key={member} className="flex items-center gap-2">
                                        <span className="h-1 w-1 rounded-full bg-red-500" />
                                        {member}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="relative">
                        <img
                            alt="Documento historico fundacion"
                            className="w-full border-2 border-white/10 object-cover shadow-2xl brightness-75 transition duration-700 hover:brightness-100"
                            src={heroImage}
                        />
                        <div className="pointer-events-none hidden md:block absolute inset-0 translate-x-4 translate-y-4 border-2 border-red-500/30" />
                    </div>
                </div>
            </section>

            <section>
                <div className="rounded-r-lg border-l-4 border-green-500 bg-gradient-to-r from-emerald-900/40 to-red-900/40 px-5 py-5 backdrop-blur-sm md:px-8">
                    <div className="flex items-center justify-between gap-4">
                        <h2 className="text-2xl md:text-3xl font-black uppercase tracking-wider text-white">
                            Socios fundadores
                        </h2>
                        <span className="shrink-0 border border-green-400/30 bg-green-500/10 px-3 py-1 text-xs font-bold tracking-widest text-green-300">
                            {foundingMembers.length} NOMBRES
                        </span>
                    </div>
                </div>
                <div className="mt-6 border border-white/10 bg-[#0b2218]/70 p-3 shadow-xl md:mt-12 md:p-5">
                    <ul className="grid grid-cols-2 gap-2 lg:grid-cols-3">
                        {foundingMembers.map((member, index) => (
                            <li key={member} className="flex items-center gap-3 border border-white/5 bg-white/[0.03] px-4 py-3 text-sm text-slate-200 transition-colors duration-300 hover:border-green-500/30 hover:bg-green-500/10">
                                <span className="flex h-6 w-6 shrink-0 items-center justify-center border border-red-500/40 text-xs font-bold text-red-300">
                                    {String(index + 1).padStart(2, "0")}
                                </span>
                                {member}
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <section className="grid items-center gap-8 md:grid-cols-2 md:gap-16">
                <div className="relative order-2 md:order-1">
                    <img
                        alt="Plaza de Deportes N1"
                        className="w-full border-2 border-white/10 object-cover shadow-2xl brightness-75 transition duration-700 hover:brightness-100"
                        src={canchaImage}
                    />
                    <div className="pointer-events-none hidden md:block absolute inset-0 translate-x-4 translate-y-4 border-2 border-red-500/30" />
                </div>
                <div className="order-1 space-y-5 md:space-y-8 md:order-2">
                    <div className="rounded-r-lg border-l-4 border-green-500 bg-gradient-to-r from-emerald-900/40 to-red-900/40 px-5 py-5 backdrop-blur-sm md:px-8">
                        <h2 className="text-2xl md:text-3xl font-black uppercase tracking-wider text-white">
                            Los primeros lugares
                        </h2>
                    </div>
                    <p className="text-lg leading-relaxed text-slate-300">
                        La primera dirección oficial fue Agraciada 2069, junto a la Plaza de Deportes N. 1, hoy avenida del Libertador entre Venezuela y Nicaragua. Liderada por Primo Gianotti, esa plaza fue el escenario de los primeros sueños aguateros, frente a la Iglesia de la Aguada y cerca del Palacio Legislativo en construcción.
                    </p>
                </div>
            </section>

            <section>
                <div className="rounded-r-lg border-l-4 border-green-500 bg-gradient-to-r from-emerald-900/40 to-red-900/40 px-5 py-5 backdrop-blur-sm md:px-8">
                    <h2 className="text-2xl md:text-3xl font-black uppercase tracking-wider text-white">
                        El origen de los colores
                    </h2>
                </div>
                <div className="mx-auto mt-6 md:mt-12 flex max-w-3xl flex-col items-center space-y-6 md:space-y-8 text-center">
                    <p className="text-base md:text-xl leading-relaxed text-slate-300">
                        Nuestros colores son un homenaje a la familia Di Corcia y a sus raíces italianas. El <span className="font-black text-green-400">verde</span> y el <span className="font-black text-red-400">rojo</span>, inspirados en la bandera de Italia, se transformaron con el tiempo en una de las señas de identidad más fuertes del Club Atlético Aguada.
                    </p>
                    <p className="text-base md:text-xl leading-relaxed text-slate-300">
                        El primer delegado que representó a Aguada ante la Federación Uruguaya de Básquetbol fue Rodolfo Di Corcia, quien el 22 de junio de 1925 oficializó las características de la camiseta del club, dejando constancia de que: «El Club A. Aguada usará camiseta a franjas horizontales <span className="font-bold text-green-400">verdes</span> y <span className="font-bold text-red-400">rojas</span>".
                    </p>
                    <div className="flex h-12 w-full gap-4">
                        <div className="flex-1 rounded-l-lg bg-green-500/80" />
                        <div className="flex-1 bg-white/90" />
                        <div className="flex-1 rounded-r-lg bg-red-500/80" />
                    </div>
                </div>
            </section>

            <section className="grid gap-8 md:grid-cols-2 md:gap-16">
                <div className="space-y-4 md:space-y-8">
                    <h3 className="flex items-center gap-3 text-xl md:text-2xl font-bold text-white">
                        <span className="h-1 w-10 bg-red-500" /> Un club polideportivo
                    </h3>
                    <p className="leading-relaxed text-slate-400">
                        En sus primeros años, Aguada también compitió en atletismo, voleibol, patín, natación, esgrima y fútbol, en una época de grandes triunfos deportivos uruguayos a nivel regional y olímpico.
                    </p>
                </div>
                <div className="space-y-4 md:space-y-8">
                    <h3 className="flex items-center gap-3 text-xl md:text-2xl font-bold text-white">
                        <span className="h-1 w-10 bg-green-500" /> La llegada del básquetbol
                    </h3>
                    <p className="leading-relaxed text-slate-400">
                        Aguada comenzó a jugar al básquetbol en la Plaza 1 y se afilió a la Federación Uruguaya de Básquetbol en 1925 para iniciar sus competencias oficiales en Intermedia.
                    </p>
                </div>
            </section>

            <div className="h-px w-full bg-gradient-to-r from-transparent via-white/10 to-transparent" />

            <section className="relative">
                <span className="pointer-events-none absolute -left-2 -top-10 select-none text-5xl font-black text-red-500/20 md:text-6xl">
                    8 AGO 1925
                </span>
                <div className="rounded-r-lg border-l-4 border-green-500 bg-gradient-to-r from-emerald-900/40 to-red-900/40 px-5 py-5 backdrop-blur-sm md:px-8">
                    <h2 className="text-2xl md:text-3xl font-black uppercase tracking-wider text-white">
                        El primer partido oficial
                    </h2>
                    <p className="mt-2 text-lg font-bold text-green-400">8 de agosto de 1925</p>
                </div>

                <div className="mt-6 md:mt-12 space-y-8 rounded-xl border border-white/10 bg-gradient-to-b from-[#102216] to-[#062a1a] p-6 text-center md:p-12">
                    <div className="flex items-center justify-center gap-8 md:gap-24">
                        <div className="text-center">
                            <div className="mb-2 text-4xl font-black text-white md:text-6xl">15</div>
                            <div className="text-sm font-bold uppercase tracking-widest text-red-400">Aguada</div>
                        </div>
                        <div className="text-2xl font-black text-slate-700">VS</div>
                        <div className="text-center">
                            <div className="mb-2 text-4xl font-black text-white md:text-6xl">09</div>
                            <div className="text-sm font-bold uppercase tracking-widest text-slate-400">Uruguay Asoc.</div>
                        </div>
                    </div>
                    <p className="mx-auto max-w-2xl text-lg text-slate-300">
                        El domingo 8 de agosto, por la mañana y en la Plaza 1, Aguada venció a <span className="text-white">Uruguay Asociación</span>. Rodolfo Di Corcia convirtió el primer doble de la historia aguatera; también debutaron Souto, Lomé, Verzi, Hugo Di Corcia y Valls.
                    </p>
                </div>
            </section>

            <div className="h-px w-full bg-gradient-to-r from-transparent via-white/10 to-transparent" />

            <section>
                <div className="rounded-r-lg border-l-4 border-green-500 bg-gradient-to-r from-emerald-900/40 to-red-900/40 px-5 py-5 backdrop-blur-sm md:px-8">
                    <h2 className="text-2xl md:text-3xl font-black uppercase tracking-wider text-white">
                        Los primeros hitos
                    </h2>
                </div>
                <div className="mt-6 md:mt-12 grid gap-6 md:grid-cols-3">
                    {firstTitles.map((title) => (
                        <article key={title.year} className={`rounded-lg border-b-4 ${title.borderClass} bg-[#102216] p-6 md:p-8`}>
                            <h3 className="mb-4 text-4xl font-black text-white">{title.year}</h3>
                            <p className="text-slate-400">{title.description}</p>
                        </article>
                    ))}
                </div>
            </section>

        </div>
    );
}

export default FundacionContent;
